export function login({
  phoneNumber,
  countryCode,
  encData,
  history,
  resend,
  queryParams = '',
  reVerify = false,
  ssoInfo = {},
  storedUTMParams = {},
  emailCode = null,
  emailVerificationId = null,
  channel = null,
}) {
  return {
    type: 'LOGIN',
    payload: {
      phoneNumber,
      countryCode,
      encData,
      history,
      resend,
      queryParams,
      reVerify,
      ssoInfo,
      storedUTMParams,
      emailCode,
      emailVerificationId,
      channel,
    },
  };
}

export function logout(history) {
  return {
    type: 'LOGOUT',
    payload: {
      history,
    },
  };
}

export function loginMagicLink(magicLink, history, tab, platform, sourceId) {
  return {
    type: 'SSO_MAGIC_CODE',
    payload: {
      magicLink,
      history,
      tab,
      platform,
      sourceId,
    },
  };
}

export function loginPhonepe(grantToken, history, queryParams) {
  return {
    type: 'SSO_PHONEPE',
    payload: {
      grantToken,
      history,
      queryParams,
    },
  };
}

export function loginSso(
  encrypted,
  clientId,
  history,
  userInfo,
  data,
  ssoType
) {
  return {
    type: 'SSO_LOGIN',
    payload: {
      encrypted,
      clientId,
      history,
      userInfo,
      data,
      ssoType,
    },
  };
}

export function loginWithToken(authorization, queryParams, history) {
  return {
    type: 'LOGIN_WITH_TOKEN',
    payload: {
      authorization,
      queryParams,
      history,
    },
  };
}

export function redeemUpsellToken(ott, onSuccess, onFailure) {
  return {
    type: 'UPSELL_REDEEM_TOKEN',
    payload: {
      ott,
      onSuccess,
      onFailure,
    },
  };
}

export function verifyOtp(
  phoneNumber,
  otp,
  history,
  queryParams,
  ssoInfo,
  emailCode = null,
  hexCode = null
) {
  return {
    type: 'VERIFY_OTP',
    payload: {
      phoneNumber,
      otp,
      history,
      queryParams,
      ssoInfo,
      emailCode,
      hexCode,
    },
  };
}

export function verifyEmailOtp(
  email,
  otp,
  history,
  queryParams,
  ssoInfo,
  otpVerifier
) {
  return {
    type: 'VERIFY_EMAIL_OTP',
    payload: {
      email,
      otp,
      history,
      queryParams,
      ssoInfo,
      otpVerifier,
    },
  };
}

export function emailOtpSent(email, otpVerifier, otpVerificationDescription) {
  return {
    type: 'EMAIL_OTP_SENT',
    payload: {
      email,
      otpVerifier,
      otpVerificationDescription,
    },
  };
}

export function submitUserDetails(name, dob, gender, history) {
  return {
    type: 'SUBMIT_USER_INFO',
    payload: {
      name,
      dob,
      gender,
      history,
    },
  };
}

export function submitSsoMissingFields(fields, clientId, encrypted, history) {
  return {
    type: 'SUBMIT_SSO_MISSING_FIELDS',
    payload: {
      fields,
      clientId,
      encrypted,
      history,
    },
  };
}

export function updateLoginState(state) {
  return {
    type: 'UPDATE_LOGIN_STATE',
    payload: {
      state,
    },
  };
}

export function setFitcoinsBalance(balance) {
  return {
    type: 'SET_FITCOIN_BALANCE',
    payload: {
      balance,
    },
  };
}

export function addChatMessage(chatMessage) {
  return {
    type: 'ADD_CHAT_MESSAGE',
    payload: {
      chatMessage,
    },
  };
}

export function setChatInfo(chatInfo) {
  return {
    type: 'SET_CHAT_INFO',
    payload: {
      ...chatInfo,
    },
  };
}

export function setChatMessages(chatMessages) {
  console.log(chatMessages);
  return {
    type: 'SET_CHAT_MESSAGES',
    payload: {
      chatMessages,
    },
  };
}

export function resetChat() {
  return {
    type: 'RESET_CHAT',
  };
}

export function getConsultationSummary() {
  return {
    type: 'GET_CONSULTATION_SUMMARY',
  };
}

export function cancelConsultationBooking(requestId, history) {
  return {
    type: 'CANCEL_CONSULTATION_BOOKING',
    payload: {
      requestId,
      history,
    },
  };
}

export function rescheduleConsultationBooking(requestId, doctorName, history) {
  return {
    type: 'RESCHEDULE_CONSULTATION_BOOKING',
    payload: {
      requestId,
      doctorName,
      history,
    },
  };
}

export function showError(errorTitle, errorDesc) {
  return {
    type: 'SHOW_ERROR',
    payload: {
      hasError: true,
      errorTitle,
      errorDesc,
    },
  };
}

export function hideError() {
  return {
    type: 'HIDE_ERROR',
    payload: null,
  };
}

export function setSearchText(text) {
  return {
    type: 'SET_SEARCH_TEXT',
    payload: text,
  };
}

export function setDoctorTyping(typing, doctorId) {
  return {
    type: 'SET_DOCTOR_TYPING',
    payload: {
      typing,
      doctorId,
    },
  };
}

export function setAppConfig(config) {
  return {
    type: 'SET_APP_CONFIG',
    payload: {
      config,
    },
  };
}

export function addBotChatMessage(chatMessage) {
  return {
    type: 'ADD_BOT_CHAT_MESSAGE',
    payload: {
      chatMessage,
    },
  };
}

export function setBotChatInfo(chatInfo) {
  return {
    type: 'SET_BOT_CHAT_INFO',
    payload: {
      ...chatInfo,
    },
  };
}

export function setBotChatMessages(chatMessages) {
  console.log(chatMessages);
  return {
    type: 'SET_BOT_CHAT_MESSAGES',
    payload: {
      chatMessages,
    },
  };
}

export function resetBotChat() {
  return {
    type: 'RESET_BOT_CHAT',
  };
}

export function startVideoCall(payload) {
  return {
    type: 'START_VIDEO_CALL',
    payload,
  };
}

export function stopVideoCall() {
  return {
    type: 'STOP_VIDEO_CALL',
  };
}

export function setVideoFeedbackInfo(info) {
  return {
    type: 'SET_VIDEO_FEEDBACK_INFO',
    payload: info,
  };
}

export function setManageDependentLink(link) {
  return {
    type: 'SET_MANAGE_DEPENDENT_LINK',
    payload: link,
  };
}

export function setCurrentActiveTab(value) {
  return {
    type: 'SET_CURRENT_ACTIVE_TAB',
    payload: value,
  };
}

export function setUserName(value) {
  return {
    type: 'SET_USER_NAME',
    payload: value,
  };
}

export function setUserEmail(value) {
  return {
    type: 'SET_USER_EMAIL',
    payload: value,
  };
}

export function setUserGender(value) {
  return {
    type: 'SET_USER_GENDER',
    payload: value,
  };
}

export function setTicketingUrl(value) {
  return {
    type: 'SET_TICKETING_URL',
    payload: value,
  };
}

export function showUnlockGymSession(value) {
  return {
    type: 'SHOW_UNLOCK_GYM_SESSION',
    payload: value,
  };
}

export function updateFitnessActiveTab(payload) {
  return {
    type: 'SET_FITNESS_ACTIVE_TAB',
    payload,
  };
}

export function setVideoCallData(data) {
  return {
    type: 'SET_VIDEO_DATA',
    payload: data,
  };
}

export function resetVideoData(data = false) {
  return {
    type: 'RESET_VIDEO_DATA',
    payload: data,
  };
}

export function medicalConditions(items) {
  return {
    type: 'SET_HEALTH_HISTORY',
    payload: items,
  };
}

export function weightInBmi(weight) {
  return {
    type: 'SET_WEIGHT',
    payload: weight,
  };
}

export function heightInBmi(height) {
  return {
    type: 'SET_HEIGHT',
    payload: height,
  };
}

export function bmiScore(value) {
  return {
    type: 'SET_BMI',
    payload: value,
  };
}

export function healthGoal(items) {
  return {
    type: 'SET_HEALTH_GOAL',
    payload: items,
  };
}

export function foodPreference(value) {
  return {
    type: 'SET_FOOD_PREFERENCE',
    payload: value,
  };
}

export function foodFavorite(items) {
  return {
    type: 'SET_FAV_FOOD',
    payload: items,
  };
}

export function foodAllergic(items) {
  return {
    type: 'SET_ALLERGIC_FOOD',
    payload: items,
  };
}

export function physicalActivity(value) {
  return {
    type: 'SET_PHYSICAL_ACTIVITY',
    payload: value,
  };
}

export function loggedMeal(items) {
  return {
    type: 'LOGGED_MEAL',
    payload: items,
  };
}

export function currentVaccineId(id) {
  return {
    type: 'SET_CURRENT_VACCINE_ID',
    payload: id,
  };
}

export function cultCard(item) {
  return {
    type: 'SET_CULT_CARD',
    payload: item,
  };
}

export function togglePrescriptionPopup(value) {
  return {
    type: 'TOGGLE_PRESCRIPTION_POPUP',
    payload: value,
  };
}

export function openFileViewer(value) {
  return {
    type: 'OPEN_FILE_VIEWER',
    payload: value,
  };
}

export function closeFileViewer() {
  return {
    type: 'CLOSE_FILE_VIEWER',
  };
}

export function setInitialState() {
  return {
    type: 'SET_INITIAL_STATE',
  };
}

export function clearAxiosCache() {
  return {
    type: 'REMOVE_AXIOS_CACHE',
  };
}
export function vaccinationCategoryIdAction(value) {
  console.log('vaccinationCategoryIdAction', value);
  return {
    type: 'VACCINATION_CATEGORY_ID_FILTERS',
    payload: value,
  };
}

export function vaccinationCategoryNameAction(value) {
  return {
    type: 'VACCINATION_CATEGORY_NAME_FILTERS',
    payload: value,
  };
}

export function addFeedback(feedback) {
  return {
    type: 'ADD_FEEDBACK',
    payload: feedback,
  };
}

export function resetFeedback() {
  return {
    type: 'RESET_FEEDBACK',
  };
}

export function setUserNameFeedback(userName) {
  return {
    type: 'SET_USER_NAME_FEEDBACK',
    payload: userName,
  };
}

export function resetUserNameFeedback() {
  return {
    type: 'RESET_USER_NAME_FEEDBACK',
  };
}

export function removeFeedbackByType(type) {
  return {
    type: 'REMOVE_FEEDBACK_BY_TYPE',
    payload: type,
  };
}

export function updateRecentSearches(q) {
  console.log('updateRecentSearches', q);
  return {
    type: 'SEARCH_BOOK_RECENT_SEARCH',
    payload: q,
  };
}
export function setSearchBookCartItems(q) {
  return {
    type: 'SET_SEARCH_BOOK_CART_ITEMS',
    payload: q,
  };
}
export function updateSearchBookCartItems(q) {
  return {
    type: 'SEARCH_BOOK_CART_ITEMS',
    payload: q,
  };
}
export function updateUserEmail(q) {
  return {
    type: 'SEARCH_BOOK_USER_EMAIL',
    payload: q,
  };
}
export function setLinkedBenefitsData(data) {
  return {
    type: 'SET_LINKED_BENEFITS_DATA',
    payload: data,
  };
}
export function resetLinkedBenefitsData() {
  return {
    type: 'RESET_LINKED_BENEFITS_DATA',
  };
}
export function setWiproUser(payload) {
  console.log('setWipro', payload);
  return {
    type: 'IS_WIPRO_USER',
    payload: payload,
  };
}

export const setResponseDataVerifyOtp = (data) => ({
  type: 'SET_RESPONSE_DATA',
  payload: data,
});

export const tick = () => ({
  type: 'TICK',
});

export const setTimeoutVerification = (data) => ({
  type: 'SET_TIMEOUT_VERIFICATION',
  payload: data,
});

export function getPreBookedProcesses(callback) {
  return {
    type: 'GET_PRE_BOOKED_PROCESSES',
    payload: {
      callback,
    },
  };
}

export function getLandingPageData(centerId) {
  return {
    type: 'GET_LANDING_PAGE_DATA',
    payload: centerId,
  };
}

export function setLandingPageData(data) {
  return {
    type: 'SET_LANDING_PAGE_DATA',
    payload: data,
  };
}

export function updateIframeFlag(value) {
  return {
    type: 'SET_IFRAME_FLAG',
    payload: value,
  };
}
